import { render, staticRenderFns } from "./wzbRight.vue?vue&type=template&id=bc133932&scoped=true&"
import script from "./wzbRight.vue?vue&type=script&lang=js&"
export * from "./wzbRight.vue?vue&type=script&lang=js&"
import style0 from "./wzbRight.vue?vue&type=style&index=0&id=bc133932&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc133932",
  null
  
)

export default component.exports